import { ProgramService } from "@adfenix/types";

export const getDefaultNotification =
  (): ProgramService.ProgramTicketModel => ({
    // We need a temporary local identifier to be able to move notifications between email and ticket lists when type is switched
    // We use a timestamp which is used for sorting so the order of the notifications is preserved when switching between types
    id: `{temporary-id-${Date.now()}}`,
    delayUntilSubjectPassesPublicationLimitation: false,
    delayBeforeSending: null
  });
